import React from "react";
import {
  ChevronLeft,
  ChevronRight,
  CalendarDays,
  Clock3,
  Monitor,
  Video,
  Phone,
} from "lucide-react";

const FollowupSessions = () => {
  const days = [
    "", "", "", "1", "2", "3", "4",
    "5", "6", "7", "8", "9", "10", "11",
    "12", "13", "14", "15", "16", "17", "18",
    "19", "20", "21", "22", "23", "24", "25",
    "26", "27", "28", "29", "30", "", "",
  ];

  const morningSlots = [
    "09:00 AM",
    "09:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:30 AM",
  ];

  const afternoonSlots = [
    "01:00 PM",
    "01:30 PM",
    "02:30 PM",
    "03:00 PM",
    "04:30 PM",
  ];

  return (
    <div className="w-full font-lato">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl font-semibold text-[#24312d] leading-tight">
          Book Follow-up Session
        </h2>
        <p className="text-[#98a19b] text-sm mt-2">
          Schedule your next consultation with your dedicated specialist.
        </p>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[1fr_320px] gap-6">
        <div className="space-y-6">
          <div className="bg-white border border-[#e8ece8] rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 rounded-full bg-[#58b96b] text-white text-[13px] font-semibold flex items-center justify-center">
                1
              </span>
              <h3 className="text-[18px] font-semibold text-[#24312d]">
                Select Date
              </h3>
            </div>

            <div className="flex items-center justify-between mb-6">
              <h4 className="text-[14px] font-semibold text-[#24312d]">
                November 2024
              </h4>

              <div className="flex items-center gap-2">
                <button className="w-8 h-8 border border-[#dfe5df] rounded-md flex items-center justify-center hover:bg-gray-50">
                  <ChevronLeft size={14} />
                </button>

                <button className="w-8 h-8 border border-[#dfe5df] rounded-md flex items-center justify-center hover:bg-gray-50">
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-7 gap-3 mb-4">
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
                <div
                  key={day}
                  className="text-center text-[12px] text-[#a0a8a2] font-medium"
                >
                  {day}
                </div>
              ))}
            </div>

            <div className="grid grid-cols-7 gap-3">
              {days.map((day, i) => {
                const active = day === "14";
                const disabled = day === "9" || day === "16" || day === "17" || day === "23" || day === "24" || day === "30";

                return (
                  <button
                    key={i}
                    className={`h-[52px] rounded-lg text-[14px] font-medium transition ${
                      day === ""
                        ? "cursor-default"
                        : active
                        ? "bg-[#58b96b] text-white"
                        : disabled
                        ? "text-[#d1d6d2] cursor-not-allowed"
                        : "text-[#24312d] hover:bg-[#f7f9f7]"
                    }`}
                    disabled={disabled || day === ""}
                  >
                    {day}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="bg-white border border-[#e8ece8] rounded-xl p-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-7 h-7 rounded-full bg-[#58b96a] text-white text-[13px] font-medium flex items-center justify-center">
                2
              </span>
              <h3 className="text-[15px] font-semibold text-[#24312d]">
                Select Time
              </h3>
            </div>

            <div className="mb-5">
              <p className="text-[11px] font-medium text-[#a0a8a2] uppercase mb-3">
                Morning
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                {morningSlots.map((slot, index) => (
                  <button
                    key={index}
                    className={`h-[42px] rounded-md border text-[13px] transition ${
                      slot === "11:30 AM"
                        ? "bg-[#58b96a] border-[#58b96a] text-white"
                        : "border-[#e1e6e1] text-[#24312d] hover:border-[#58b96a]"
                    }`}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[11px] font-medium text-[#a0a8a2] uppercase mb-3">
                Afternoon
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                {afternoonSlots.map((slot, index) => (
                  <button
                    key={index}
                    className="h-[42px] rounded-md border border-[#e1e6e1] text-[13px] text-[#24312d] hover:border-[#58b96a] transition"
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-white border border-[#e8ece8] rounded-xl p-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-7 h-7 rounded-full bg-[#58b96a] text-white text-[13px] font-medium flex items-center justify-center">
                3
              </span>
              <h3 className="text-[15px] font-semibold text-[#24312d]">
                Choose Mode
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <button className="border border-[#58b96a] bg-[#f7fcf8] rounded-xl p-6 text-center transition">
                <div className="w-10 h-10 rounded-full bg-[#58b96a] mx-auto flex items-center justify-center mb-4">
                  <Video size={18} className="text-white" />
                </div>

                <h4 className="text-[15px] font-semibold text-[#24312d] mb-1">
                  Video Call
                </h4>

                <p className="text-[12px] text-[#97a09a]">
                  Secure video consultation
                </p>
              </button>

              <button className="border border-[#e1e6e1] rounded-xl p-6 text-center hover:border-[#58b96a] transition">
                <div className="w-10 h-10 rounded-full bg-[#f7f9f7] mx-auto flex items-center justify-center mb-4">
                  <Phone size={18} className="text-[#58b96a]" />
                </div>

                <h4 className="text-[15px] font-semibold text-[#24312d] mb-1">
                  Voice Call
                </h4>

                <p className="text-[12px] text-[#97a09a]">
                  Standard audio consultation
                </p>
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white border border-[#e8ece8] rounded-xl p-6 h-fit">
          <h3 className="text-[18px] font-semibold text-[#24312d] mb-6">
            Booking Summary
          </h3>

          <div className="text-center mb-6">
            <img
              src="https://i.pravatar.cc/100?img=32"
              alt="doctor"
              className="w-16 h-16 rounded-full object-cover mx-auto mb-4"
            />

            <h4 className="text-[18px] font-semibold text-[#24312d] leading-tight">
              Dr. Emily Chen
            </h4>

            <p className="text-[13px] text-[#98a19b] mt-1">
              Senior Nutritionist
            </p>
          </div>

          <div className="border-t border-[#edf1ed] pt-5 space-y-5">
            <div className="flex gap-3">
              <CalendarDays size={16} className="text-[#98a19b] mt-1" />
              <div>
                <p className="text-[12px] text-[#98a19b]">Date</p>
                <p className="text-[14px] font-medium text-[#24312d] mt-1">
                  Thursday, Nov 14, 2024
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <Clock3 size={16} className="text-[98a19b] mt-1" />
              <div>
                <p className="text-[12px] text-[#98a19b]">Time</p>
                <p className="text-[14px] font-medium text-[#24312d] mt-1">
                  11:30 AM - 12:15 PM
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <Monitor size={16} className="text-[#98a19b] mt-1" />
              <div>
                <p className="text-[12px] text-[#98a19b]">
                  Consultation Mode
                </p>
                <p className="text-[14px] font-medium text-[#24312d] mt-1">
                  Video Call
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-[#edf1ed] mt-6 pt-5 flex items-center justify-between">
            <span className="text-[14px] text-[#98a19b]">Session Fee</span>
            <span className="text-[14px] font-semibold text-[#58b96b]">
              Included in Plan
            </span>
          </div>

          <button className="w-full h-[44px] mt-6 rounded-md bg-[#58b96b] text-white text-[14px] font-medium transition hover:bg-[#4a9e5a]">
            Confirm Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default FollowupSessions;